<template>
  <button
    type="button"
    class="segmented-button"
    :class="{ 'is-selected': selected }"
    :aria-pressed="selected"
    @click="emit('click')"
  >
    {{ label }}
  </button>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["click"]);
</script>
